// @flow
/* eslint-disable no-nested-ternary */

import * as React from 'react';

import { Alert, Base } from '@gandi/ui';
import type { TranslatorProps } from '@gandi/translate';

import styles from './PhishingAlert.scss';

type Props = {|
  showSupportWarn: boolean,
  showPhishingWarn: boolean,
  translator: TranslatorProps,
|};

const PhishingAlert = (props: Props) => {
  if (props.showPhishingWarn || props.showSupportWarn) {
    return (
      <Base marginBottom="base">
        <Alert
          className={styles.alert}
          message={
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: props.showSupportWarn
                  ? props.translator.__(
                      '<strong>Information</strong> : We are currently experiencing a higher-than-usual number of support requests, ' +
                        'which has created a response time that is longer than usual for us. ' +
                        'Please be assured that each request will be handled by our team, ' +
                        'and accept our apologies for this unusual event. ' +
                        'We are doing everything possible to return the situation to normal as fast as possible.<br />' +
                        'If you are experiencing problems logging into our website, ' +
                        'you may find the help you need in our documentation at ' +
                        '<a href="https://docs.gandi.net/en/account_management">' +
                        'https://docs.gandi.net/en/account_management</a>.'
                    )
                  : props.showPhishingWarn
                  ? props.translator.__(
                      '<strong>SECURITY ALERT</strong>: If you got an unexpected email from support@gandi.net ' +
                        'in French concerning a payment, IGNORE the message. It is a fraudulent mail.<br>' +
                        'For more information and what to do: ' +
                        '<a href="https://news.gandi.net/en/2019/06/spoofing-phishing-and-gandi-what-you-need-to-know/">' +
                        'https://news.gandi.net/en/2019/06/spoofing-phishing-and-gandi-what-you-need-to-know/</a>.'
                    )
                  : '',
              }}
            />
          }
          intent="warning"
        />
      </Base>
    );
  }
  return <div className={styles.spacing} />;
};

export default (React.memo(PhishingAlert): React.AbstractComponent<Props>);
